import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import { useSwipeable } from 'react-swipeable';
import { Show } from '../../show';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import IconButton from '../../icon-button';

import CloseIcon from '../assets/multiply.svg?react';
import LeftArrowPath from '../assets/chevron-white-left.svg?react';
import RightArrowPath from '../assets/chevron-white-right.svg?react';

export const ContainerOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: var(--gray900);
    z-index: 10;
    cursor: pointer;
`;

export const OverlayContent = styled.div`
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Image = styled.img`
    display: block;
    max-width: 100%;
    max-height: 100vh;
    cursor: initial;
`;

export const TopBar = styled.div`
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    padding: 16px;
    box-sizing: border-box;
    background-color: #333333b3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
`;

export const PreviousArrow = styled.div`
    position: absolute;
    left: 0px;
    padding-left: 8px;

    &:focus {
        outline: none;
    }
`;

export const NextArrow = styled.div`
    position: absolute;
    right: 0;
    padding-right: 8px;

    &:focus {
        outline: none;
    }
`;

export const LeftArrow = styled(LeftArrowPath)`
    ${({ theme }) => css`
        fill: ${theme.colors['text-white']};

        &[disabled] {
            fill: ${theme.colors['surface-grey-700']};
        }
    `}
`;

export const RightArrow = styled(RightArrowPath)`
    ${({ theme }) => css`
        fill: ${theme.colors['text-white']};

        &[disabled] {
            fill: ${theme.colors['surface-grey-700']};
        }
    `}
`;

const LightboxGallery = ({ images, onClose, index = 0 }) => {
    const [imageIndex, setImageIndex] = useState(index);
    const image = images[imageIndex];
    const size = images.length;
    const caption = image.caption ? `${image.caption} - ` : '';
    const title = `${caption}${imageIndex + 1}/${size}`;

    const next = () => {
        if (imageIndex + 1 < size) {
            setImageIndex(imageIndex + 1);
        }
    };

    const prev = () => {
        if (imageIndex > 0) {
            setImageIndex(imageIndex - 1);
        }
    };

    const swipeHandler = useSwipeable({ onSwipedLeft: next, onSwipedRight: prev });

    const handleKeyDown = (e) => {
        if (e.code === 'ArrowRight') {
            next();
        } else if (e.code === 'ArrowLeft') {
            prev();
        }
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            document.body.style.overflow = 'auto';
            window.removeEventListener('keydown', handleKeyDown);
        };
    });

    return (
        <ContainerOverlay {...swipeHandler}>
            <TransformWrapper doubleClick={{ mode: 'reset' }}>
                <TransformComponent>
                    <OverlayContent>
                        <Show when={size > 1 && imageIndex > 0}>
                            <PreviousArrow tabIndex="0" onClick={prev}>
                                <LeftArrow />
                            </PreviousArrow>
                        </Show>
                        <Image src={image.src} onClick={(event) => event.stopPropagation()} alt={image.alt} />
                        <Show when={size > 1 && imageIndex + 1 < images.length}>
                            <NextArrow tabIndex="0" onClick={next}>
                                <RightArrow />
                            </NextArrow>
                        </Show>
                    </OverlayContent>
                </TransformComponent>
            </TransformWrapper>
            <TopBar>
                <span>{title}</span>
                <IconButton type="secondary" size="small" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </TopBar>
        </ContainerOverlay>
    );
};

LightboxGallery.propTypes = {
    images: PropTypes.array.isRequired,
    index: PropTypes.number,
    onClose: PropTypes.func,
};

export default LightboxGallery;
